export default __webpack_public_path__ + "static/media/SLSTM1.53c7ec37.png";